export const InfoTextsEnum = {
  GENERAL_INFO: 'Allgemeine Information',
  TECH_INFO: 'Technische Information',
};
